import { render, staticRenderFns } from "./CatalogueSingleSideButtons.vue?vue&type=template&id=9f53f6aa&scoped=true&lang=pug&"
import script from "./CatalogueSingleSideButtons.vue?vue&type=script&lang=js&"
export * from "./CatalogueSingleSideButtons.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueSingleSideButtons.vue?vue&type=style&index=0&id=9f53f6aa&lang=scss&scoped=true&"
import style1 from "./CatalogueSingleSideButtons.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f53f6aa",
  null
  
)

export default component.exports